"use client";
import { ErrorAlert } from "@/utils/NotificationFunctions";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const serverError =
    "An error occurred in the Server Components render but no message was provided";
  useEffect(() => {
    if (error.message === serverError) {
      const message = `<div style="color: white; font-family: 'font-light'; font-weight: bold; text-align: start ">There is a problem with the server. Please try again later.</div>`;
      ErrorAlert(message);
    }
  }, [error]);

  return (
    <div className="bg-black text-white w-full h-full items-center flex flex-col justify-center gap-4">
      <h2>Something went wrong:</h2>
      <p>{error.message}</p>
      <button onClick={() => reset()} className="bg linear-bg p-4 rounded">
        Try again
      </button>
    </div>
  );
}
